import { Button, ClickEvent, DataSourceExecutionEvent, Layout, LayoutProps, SlideoutDecorator, Snackbar, Table } from "@mcleod/components";
import { Api } from "@mcleod/core";
import { AutogenLayoutRatewareControl } from "./autogen/AutogenLayoutRatewareControl";
import { AvailableRatewareTariffs } from "./AvailableRatewareTariffs";

interface RatewareControlLayoutProps extends LayoutProps {
    vendorId: string;
}

export class RatewareControl extends AutogenLayoutRatewareControl {
    private _vendorId: string;

    constructor(props?: Partial<RatewareControlLayoutProps>) {
        super(props);
        this._vendorId = props?.vendorId;
    }

    async onLoad() {
        this.buttonTestConnection.doOnDataSourceChanged = (ds, value) => {  this.buttonTestConnection.enabled = !value; }
        this.mainDataSource.addHasChangedComponent(this.buttonTestConnection);

        this.buttonViewTariffs.doOnDataSourceChanged = (ds, value) => { this.buttonViewTariffs.enabled = !value; }
        this.mainDataSource.addHasChangedComponent(this.buttonViewTariffs);

        this.buttonTestConnection.disabledTooltip = "You cannot Test Connection because something has changed or service not Active";
        this.buttonViewTariffs.disabledTooltip = "You cannot View Available Tariffs because something has changed or service not Active";
    }

    sourceContractManagementControlAfterExecution(event: DataSourceExecutionEvent) {
        this.buttonTestConnection.enabled = this.checkboxActive.checked;
        this.buttonViewTariffs.enabled = this.checkboxActive.checked;
    }


    async postDataSources(vendorId: string): Promise<boolean> {
        try {
            this.mainDataSource?.activeRow?.set("id", vendorId);
            await this.mainDataSource.post();
            return true;
        } catch (error) {
            return false;
        }
    }

    buttonTestConnectionOnClick(event: ClickEvent) {
        const createButton: Button = event.target as Button;
        createButton.busy = true;
        Api.post("lme/powerbroker/rateware-api-test-connection").then(result => {
            createButton.busy = false;
            if (result) {
                const message: string = result?.data[0]?.message;
                Snackbar.showSnackbar(message);
            }
        });
    }

    buttonViewTariffsOnClick(event: ClickEvent) {
        const availableButton: Button = event.target as Button;
        const layout: AvailableRatewareTariffs = Layout.getLayout("lme/powerbroker/ltl/AvailableRatewareTariffs") as AvailableRatewareTariffs;
        const table = event.target as Table;

        const slideoutDecorator = new SlideoutDecorator({
            title: "Available Rateware Tariffs",
            layout: layout,
            fillVerticalSpace: true,
            width: 750,
            overlayProps: { greyedBackground: true },
            onClose: async (cancelled: boolean) => {
                layout.slideOut();
            },
            layoutLoadListeners: async () => {
                await layout.sourceRatewareTariffCode.search().then((result) => {
                    availableButton.busy = false;
                    const message: string = result.modelRows[0].data.message;
                    if (message)
                        Snackbar.showSnackbar(message);
                })
            }
        });
    }
}
